/* FLICK-S: sanftes Scroll-Reveal fuer Sections. Additiv, kein Framework noetig. */
(function () {
  "use strict";

  var prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function markAllVisible() {
    document.querySelectorAll(".flx-reveal").forEach(function (el) {
      el.classList.add("flx-in-view");
    });
  }

  function init() {
    var targets = document.querySelectorAll(".shopify-section:not(.flx-reveal-off)");
    // Footer-Sections (Newsletter-Block + rechtliche Links/Copyright ganz unten)
    // von der Reveal-Animation ausnehmen: Die IntersectionObserver-rootMargin
    // unten (-10%) blendet die letzten 10% des Viewports aus der Trefferzone
    // aus. Ist die letzte Section der Seite (z.B. die schmale Utilities-Leiste
    // mit Copyright/Impressum/AGB) kuerzer als dieser Streifen, landet sie bei
    // maximalem Scroll komplett in der ausgeblendeten Zone und wird NIE als
    // "intersecting" erkannt -> bleibt dauerhaft bei opacity:0 haengen (auf
    // Desktop reproduzierbar, da die Section dort kompakter/grid-foermig und
    // damit niedriger ist als auf Mobile). Da eine Fade-in-Animation fuer
    // Footer-Inhalte ohnehin keinen Mehrwert hat (man ist beim Erreichen
    // bereits ganz unten), einfach direkt sichtbar lassen statt zu animieren.
    targets = Array.prototype.filter.call(targets, function (el) {
      return !el.closest("footer");
    });
    if (!targets.length) return;

    if (prefersReducedMotion || !("IntersectionObserver" in window)) {
      targets.forEach(function (el) { el.classList.add("flx-reveal", "flx-in-view"); });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("flx-in-view");
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: "0px 0px -10% 0px", threshold: 0.1 }
    );

    targets.forEach(function (el) {
      el.classList.add("flx-reveal");
      observer.observe(el);
    });
  }

  // Entzerrung: Die Hintergrund-SVG wird per preserveAspectRatio="none" auf die
  // (hohe/schmale) Flaeche gestreckt -> runde Symbole wuerden laenglich. Pro
  // Ebene --flx-squash = (Breiten-Skalierung / Hoehen-Skalierung) setzen; die
  // CSS-Regel .flx-sym-squash dreht die vertikale Ueberdehnung wieder heraus.
  function updateSquash() {
    document.querySelectorAll(".flx-bg-paths").forEach(function (layer) {
      var svg = layer.querySelector("svg");
      if (!svg || !svg.viewBox || !svg.viewBox.baseVal) return;
      var vb = svg.viewBox.baseVal;
      var w = layer.clientWidth;
      var h = layer.clientHeight;
      if (!w || !h || !vb.width || !vb.height) return;
      var scaleX = w / vb.width;
      var scaleY = h / vb.height;
      if (!scaleY) return;
      layer.style.setProperty("--flx-squash", scaleX / scaleY);
    });
  }

  function initBgHeight() {
    var el = document.querySelector(".flx-bg-paths--fixed");
    if (!el) { updateSquash(); return; }
    var lastHeight = 0;
    var scheduled = false;
    function measure() {
      scheduled = false;
      var height = Math.max(document.body.scrollHeight, document.documentElement.scrollHeight);
      if (height !== lastHeight) {
        lastHeight = height;
        // Direkt als Inline-Style auf dem Element (nicht ueber eine CSS-
        // Variable) - Inline-Styles schlagen jede Stylesheet-Regel, damit gibt
        // es keine Kaskaden-Unklarheit mit dem geerbten bottom:0 der
        // .flx-bg-paths-Basisklasse mehr.
        el.style.bottom = "auto";
        el.style.height = height + "px";
      }
      // Nach jeder Hoehenmessung die Entzerrung neu berechnen (Hoehe fliesst ein).
      updateSquash();
    }
    window.addEventListener("resize", updateSquash);
    function schedule() {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(measure);
    }
    measure();
    window.addEventListener("load", schedule);
    window.addEventListener("resize", schedule);
    if ("ResizeObserver" in window) {
      new ResizeObserver(schedule).observe(document.body);
    }
    if ("MutationObserver" in window) {
      new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
    }
    // Faengt Layout-Verschiebungen ab, die nach 'load' passieren (z.B. spaet
    // hydrierte Custom Elements, nachgeladene Widgets).
    setTimeout(schedule, 800);
    setTimeout(schedule, 2500);
  }

  function initScrollSpin() {
    var spinners = document.querySelectorAll("[data-flx-scroll-spin]");
    var parallax = document.querySelectorAll("[data-flx-scroll-parallax]");
    // Begrenzte Wisch-Bewegung fuer die Hintergrund-Symbole (Philip 2026-07-30:
    // "ein bisschen im Bildschirm bewegen, links/rechts/oben/unten"). BEWUSST
    // sinusfoermig um scrollY statt linear (wie der verworfene erste Parallax-
    // Versuch) - eine lineare Verschiebung akkumuliert auf der langen Homepage
    // unbegrenzt und schiebt die Elemente irgendwann komplett aus dem Bild
    // (siehe Notiz "Root-Cause" weiter oben). Der Sinus schwingt dagegen IMMER
    // zwischen +-Amplitude hin und her, egal wie weit gescrollt wird.
    var drifters = document.querySelectorAll("[data-flx-drift-seed]");
    if ((!spinners.length && !parallax.length && !drifters.length) || prefersReducedMotion) return;

    var DRIFT_AMP_X = 16;
    var DRIFT_AMP_Y = 11;

    var ticking = false;
    function update() {
      var scrollY = window.scrollY;
      var deg = scrollY * 0.12;
      spinners.forEach(function (el) {
        var dir = parseFloat(el.getAttribute("data-flx-scroll-spin")) || 1;
        el.style.transform = "rotate(" + (deg * dir) + "deg)";
      });
      parallax.forEach(function (el) {
        var coeff = parseFloat(el.getAttribute("data-flx-scroll-parallax")) || 0;
        el.style.transform = "translateY(" + (scrollY * coeff) + "px)";
      });
      drifters.forEach(function (el) {
        var seed = parseFloat(el.getAttribute("data-flx-drift-seed")) || 0;
        var dx = Math.sin(scrollY / 340 + seed * 1.7) * DRIFT_AMP_X;
        var dy = Math.cos(scrollY / 280 + seed * 1.1) * DRIFT_AMP_Y;
        el.style.transform = "translate(" + dx.toFixed(1) + "px," + dy.toFixed(1) + "px)";
      });
      ticking = false;
    }
    window.addEventListener(
      "scroll",
      function () {
        if (!ticking) {
          requestAnimationFrame(update);
          ticking = true;
        }
      },
      { passive: true }
    );
    update();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
    document.addEventListener("DOMContentLoaded", initScrollSpin);
    document.addEventListener("DOMContentLoaded", initBgHeight);
  } else {
    init();
    initScrollSpin();
    initBgHeight();
  }

  document.addEventListener("shopify:section:load", markAllVisible);
})();
